import HandleWidgets from './partials/handle-widgets'
import HandleCheckout from './partials/handle-checkout'
import HandleTickets from './partials/handle-tickets'

window.addEventListener('load', () => {
  new HandleWidgets()
  new HandleCheckout()
  new HandleTickets()
})

